<template>
  <div class="row">
    <div class="col-md-12">
      <div class="box box-primary">
        <div class="overlay" v-if="loadingStatsMembres">
          <i class="fa fa-refresh fa-spin"></i>
        </div>
        <div class="box-header with-border">
          <h3 class="box-title">Statistiques générales pour les membres (membre affilié au moins un jour durant l'année concernée)
          </h3>
          <button class="btn btn-default btn-xs pull-right"
                  @click.prevent="getStatsMembres(true)">
            <i class="fa fa-refresh "></i>
          </button>
        </div>
        <div class="box-body">
          <table class="table table-hover table-responsive">
            <thead>
            <tr>
              <th>Année</th>
              <th>Nombre de membre distinct affilié (chiffre interne en constante évolution)</th>

              <th>Nombre de membres affiliés pour l'ADEPS <br/> (sans les membres licenciés dans les clubs non-licenciés et sans les licences administratives, actifs au moins un jour dans l'année x et dont la demande est entrée avant le 31-01-(x+1) et )</th>
              <th>Nombre de membres affiliés pour ARENA <br/> (nombre de membre dont la demande de licence a été reçue avant le 31-01-(x+1) et dont la date de début a lieu durant l'année X )</th>
<!--              <th>Nombre de licences encodées (pour vérification et débug)</th>-->
            </tr>
            </thead>
            <tbody>
            <tr v-for="stat in orderedByYear(statsMembres)">
              <td>{{ stat.annee }}</td>
              <td>{{ stat.nombre }} membres</td>

              <td>{{ stat.ADEPS }} membres</td>
              <td>{{ stat.ARENA }} membres</td>
<!--              <td>{{ stat.nombreLicences }} licences</td>-->
            </tr>
            </tbody>
            <tfoot>
              <tr>
                <td>Procédure de calcul modifiée à partir de 2023.</td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>


    <div class="col-md-6">
      <div class="box box-primary">
        <div class="overlay" v-if="loadingStatsClubs">
          <i class="fa fa-refresh fa-spin"></i>
        </div>
        <div class="box-header with-border">
          <h3 class="box-title">Statistiques générales pour les clubs</h3>
          <button class="btn btn-default btn-xs pull-right"
                  @click.prevent="getStatsClub(true)">
            <i class="fa fa-refresh "></i>
          </button>
        </div>
        <div class="box-body">
          <table class="table table-hover table-responsive">
            <thead>
            <tr>
              <th>Année</th>
              <th>Nombre de clubs</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="stat in orderedByYear(statsClubs)">
              <td>{{ stat.annee }}</td>
              <td>{{ stat.somme }} clubs</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>


    <div class="col-md-6">
      <div class="box box-primary">
        <div class="overlay" v-if="loadingStatsMembresAge">
          <i class="fa fa-refresh fa-spin"></i>
        </div>
        <div class="box-header with-border">
          <h3 class="box-title">Statistiques générales pour les membres (sans compter membres affiliés aux clubs non-affiliés)
          </h3>
          <button class="btn btn-default btn-xs pull-right"
                  @click.prevent="getStatsMembresAge(true)">
            <i class="fa fa-refresh "></i>
          </button>
        </div>
        <div class="box-body">
          <table class="table table-hover table-responsive">
            <thead>
            <tr>
              <th>Année</th>
              <th>-8</th>
              <th>8-10</th>
              <th>11-13</th>
              <th>14-17</th>
              <th>18-35</th>
              <th>35+</th>
              <th>Total</th>
            </tr>
            </thead>
            <tbody>
            <tr v-if="statsMembresAge && statsMembresAge[annee]"
                v-for="annee in getAnnees().reverse()">
              <td>{{ annee }}</td>
              <td>{{ statsMembresAge[annee][2]["0-7"] }} membres</td>
              <td>{{ statsMembresAge[annee][2]["8-10"] }} membres</td>
              <td>{{ statsMembresAge[annee][2]["11-13"] }} membres</td>
              <td>{{ statsMembresAge[annee][2]["14-17"] }} membres</td>
              <td>{{ statsMembresAge[annee][2]["18-35"] }} membres</td>
              <td>{{ statsMembresAge[annee][2]["36-120"] }} membres</td>
              <td>{{ getTotal(statsMembresAge[annee][2]) }} membres</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="col-md-12">
      <div class="box box-primary">
        <div class="overlay" v-if="loadingStatsMembresDropout">
          <i class="fa fa-refresh fa-spin"></i>
        </div>
        <div class="box-header with-border">
          <h3 class="box-title">Statistiques générales du dropout
          </h3>
          <button class="btn btn-default btn-xs pull-right"
                  @click.prevent="getStatsMembresDropout(true)">
            <i class="fa fa-refresh "></i>
          </button>
        </div>
        <div class="box-body">
          <table class="table table-hover table-responsive">
            <thead>
            <tr>
              <th>Année</th>
              <th width="100">Nombre de nouveaux affiliés</th>
              <th :colspan="getAnnees().length" style="text-align: center">Total restant des nouveaux affiliés de [ligne] en [colonne]</th>
            </tr>
            <tr>
              <th bgcolor="#c0c0c0"></th>
              <th bgcolor="#c0c0c0"></th>
              <th v-for="annee  in getAnnees()"> {{ annee }}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-if="statsMembresDropout && statsMembresDropout[annee]"
                v-for="annee in getAnnees()">
              <td>{{annee}}</td>
              <td>{{statsMembresDropout[annee]["count_nouveaux"]}}</td>
              <td :bgcolor="annee>=annee2 ? '#c0c0c0':'white'" v-for="annee2 in getAnnees()">
                <template v-if="annee>=annee2"></template>
                <template v-if="annee<annee2">
                  <span
                    :id="annee+'_'+annee2"
                    v-b-tooltip.hover
                    placement="bottom"
                    :title="statsMembresDropout[annee2]['dropout'][annee] + ' restants en '+annee2+' des nouveaux affiliés de '+annee+
                     '\n('+((100 - (statsMembresDropout[annee2]['dropout'][annee] * 100 / statsMembresDropout[annee]['count_nouveaux'])) * -1).toFixed(2)+'%)'"
                  >
                    {{statsMembresDropout[annee2]["dropout"][annee]}}
                  </span >
                  </template>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

  </div>
</template>


<script>
import {mapGetters, mapActions} from 'vuex'

var moment = require('moment')

export default {
  data() {
    return {
      statsClubs: null,
      loadingStatsClubs: false,

      statsMembres: null,
      loadingStatsMembres: false,

      statsMembresAge: null,
      loadingStatsMembresAge: false,

      statsMembresDropout: null,
      loadingStatsMembresDropout: false,
    }
  },
  props: {},
  computed: {
    ...mapGetters({
      getRoute: 'getRoute',
    }),

  },
  mounted: function () {
    this.getStatsClub()
    this.getStatsMembres()
    this.getStatsMembresAge()
    this.getStatsMembresDropout()
  },
  methods: {
    ...mapActions({
      setRecap: 'setRecap',
    }),
    getTotal: function (obj) {
      return _.reduce(obj, function (memo, item) {
        return memo + item;
      })
    },
    getAnnees: function () {
      let retour = [];
      for (let i = 2007; i <= moment().year(); i++) {
        retour.push(i)
      }
      return retour;
    },
    orderedByYear: function (obj) {
      return _.sortBy(obj, 'annee').reverse()
    },
    getStatsClub: function (force = false) {
      let self = this;
      this.loadingStatsClubs = true
      self.$http.post(this.getRoute('Statistiques.statistiquesGeneralesClubs'), {forceCache: force}).then((response) => {
        this.statsClubs = response.body
        this.loadingStatsClubs = false
      }, (response) => {
      });
    },
    getStatsMembres: function (force = false) {
      let self = this;
      this.loadingStatsMembres = true
      self.$http.post(this.getRoute('Statistiques.statistiquesGeneralesMembres'), {forceCache: force}).then((response) => {
        this.statsMembres = response.body
        this.loadingStatsMembres = false
      }, (response) => {
      });
    },
    getStatsMembresAge: function (force = false) {
      let self = this;
      this.loadingStatsMembresAge = true
      self.$http.post(this.getRoute('Statistiques.statistiquesMemberByAgeByYear'), {forceCache: force}).then((response) => {
        this.statsMembresAge = response.body
        this.loadingStatsMembresAge = false
      }, (response) => {
      });
    },
    getStatsMembresDropout: function (force = false) {
      let self = this;
      this.loadingStatsMembresDropout = true
      self.$http.post(this.getRoute('Statistiques.getDropout'), {forceCache: force}).then((response) => {
        this.statsMembresDropout = response.body
        this.loadingStatsMembresDropout = false
      }, (response) => {
      });
    }
  },
  beforeRouteUpdate(to, from, next) {
  },
  beforeRouteEnter(to, from, next) {
  },
  watch: {},
  components: {}
}
</script>



// WEBPACK FOOTER //
// src/components/Secretariat/Statistiques/General/General_abft.vue